/**
 * Javascript functionality for product pages that show multiple products at once with distinct
 * Add to Cart functionality. We call these products "explosive"
 * This will only be included on product pages.
 */
$(function () {
    // if ($('#shopify-section-static-product').length) {
        /**
         * Event listener for selecting qty from a single explosive dropdown
         */
        var qtyInputSelected = function (event) {
            let $el = $(this), $secondary = $el.siblings(".qty-input.secondary");
            $el.removeClass('please-note');

            // Replace select with text for more than 12 qty
            if (event.target.value == "13") {
              
                $el.add($secondary).toggleClass('secondary morethen-list');
                $secondary.attr('name', $el.attr('name'));
                $el.removeAttr('name');
                $el[0].removeEventListener("change", qtyInputSelected);

               // var selectedValue = $(this).val();

              // $( "select.secondary.morethen-list" ).next().css( "display", "block" );
// $el.add('input.morethen.qty-input').removeClass('d-none');

              // $el.siblings('input.morethen.qty-input').toggleClass('secondary1', $el.hasClass('secondary2'));
              // console.log('class aaaadddd');
                                           
              

                                           
                $secondary.focus();
            }
        };

        let oosClickBind = function () {
            let variantID = $(this).data('id');
            oosClick(variantID);
        }

        /**
         * For clicking on OOS buttons; this is what it takes to trigger the istock notification.
         * #explosive-oos is a hidden select box containing id->name values of oos variants
         */
        let oosClick = function (variantID) {
            let oosSelect = $('#explosive-oos');
            oosSelect.val(variantID);
            oosSelect.trigger('change');
            alertModal('iStock');
        };

        /**
         * A11y (WCAG 4.1.3 Status Messages): the visual .explosive-variant-info message is not
         * a live region, so add-to-cart confirmations/errors on the explosive experience were
         * not announced to screen readers. Mirror the message text into a shared, visually-hidden
         * aria-live region so NVDA/VoiceOver announce it. Created once and reused by id
         * (also used by gridpdp.js). Clear-then-set ensures repeated messages are re-announced.
         */
        var announceStatus = function (text) {
            if (!text) return;
            var el = document.getElementById('sr-atc-announcer');
            if (!el) {
                el = document.createElement('div');
                el.id = 'sr-atc-announcer';
                el.setAttribute('role', 'status');
                el.setAttribute('aria-live', 'polite');
                el.setAttribute('aria-atomic', 'true');
                el.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
                document.body.appendChild(el);
            }
            el.textContent = '';
            window.setTimeout(function () { el.textContent = text; }, 60);
        };

        /**
         * Adds a message above an element displaying a given message (textObj.text).
         * Acceptable textObj.classes include "warn", "fail", "success", and "mobile".
         * If textObj.dismissable is set to false, it will not replace the $form element.
         *
         * @param {*} textObj {text: string, classes: string, dismissable?: boolean}
         * @param HTMLElement $form (jQuery selected)
         */
        var variantInform = function (textObj, $form) {
            var dismissable = typeof textObj.dismissable == 'boolean' ? textObj.dismissable : true,
                messageHtml = `<${dismissable ? 'a href="javascript:void(0);"' : 'span'} class="transparent explosive-variant-info `
                    + textObj.classes + '">'
                    + textObj.text + `</${dismissable ? 'a' : 'span'}>`,
                $message = $($.parseHTML(messageHtml));
            if (dismissable) $form.hide();
            $form.siblings('.explosive-variant-info').remove();
            $form.before($message);
            $message.toggleClass('transparent');
            announceStatus($message.text()); // WCAG 4.1.3 — announce to screen readers
            if (dismissable) $message.click(function () {
                $message.remove();
                $form.show();
            });
        }

        /**
         * Updates the header's cart widget to show users the quantity of items in their cart.
         *
         * @param {*} qty int
         */
        var updateHeaderCartWidget = function (qty) {
            $('.site-header-cart--count')
                .data('header-cart-count', qty)
                .attr('data-header-cart-count', qty);
            if (qty > 0) {
                $('.site-header-cart--count').addClass('visible');
            }
        };

        /**
         * Explosive Product Page functionality for desktop
         */
        window.ExplosivePDP = function () {
            this.$elements = {
                variantForms: $('form.explosive-variant-form'),
                qtyInputs: $('.explosive-variant-qty'),
                oosButtons: $('.explosive-oos-button'),
                availabilityFields: $('.explosive-availability')
            };

            var variantFormHandler = function (event) {
                event.preventDefault();
                var $form = $(this),
                    addedQty = parseInt($form.find('.qty-input:not(.secondary)').val()),
                    cartQty = parseInt($('.site-header-cart--count').data('header-cart-count')) || 0;
                if (addedQty) {
                    $.post('/cart/add.js', $form.serialize(), null, 'json')
                        .done(function (response) {
                            updateHeaderCartWidget(addedQty + cartQty);
                            variantInform({text: "Added " + addedQty + " to Your Cart", classes: 'success'}, $form);
                        })
                        .fail(function (e) {
                            if (!e || !e.responseText) return;
                            var available = window.ExplosivePDP().getErrorStockAvailable(e);
                            // TODO: Add internationalization support
                            if (!available) variantInform({
                                text: "None Available to Add&mdash;Click Here to Continue",
                                classes: 'fail'
                            }, $form);
                            else variantInform({
                                text: "Only " + available + " Available to Add&mdash;Click Here to Continue",
                                classes: 'fail'
                            }, $form);
                        });
                } else {
                    $form.find('.qty-input:not(.secondary)').addClass('please-note');
                    //variantInform({ text: "None added to your cart&mdash;Click here then select a quantity", classes: 'warn' }, $form);
                }
            };

            this.getErrorStockAvailable = function (e) {
                var errorResponse = e.responseText, matchObj = errorResponse.match(/add\s\d*/), match;
                if (matchObj) match = errorResponse.match(/add\s\d*/)[0];
                else return 0;
                if (!match) return 0;
                return parseInt(match.split(/\s/)[1], 10);
            };

            this.init = function () {
                this.$elements.variantForms.submit(variantFormHandler);
                this.$elements.qtyInputs.find('select.qty-input').change(qtyInputSelected);
                this.$elements.oosButtons.click(oosClickBind);
                // Per-card availability via the single resolver (dropship metafield, else day-based).
                this.$elements.availabilityFields.each(function () {
                    var vid = $(this).closest('.explosive-variant').data('variant-id');
                    $(this).text(window.DTAvailability.resolveById(vid));
                });
                // # qty-message
            };
            return this;
        };

        /**
         * Explosive functionality: mobile
         */
        var MobileExplosiveHandler = function () {
            var _this = this;
            this.variantCache = {};

            this.$elements = {
                atcForm: $('.product-mobile-explosive-form'),
                atcSubmitForm: $('.mobile-explosive-atc-form'),
                atcButtonText: $('.atc-button--text'),
                atcContextMsg: $('.mobile-explosive-atc-message'),
                variantId: $('.selected-variant-id'),
                variantLabel: $(".product-mobile-explosive-variant"),
                qtyInputs: $('.mobile-explosive-variant-qty'),
                stock: $('.mobile-explosive-variant-stock .variant-stock'),
                virtualCart: $('.pending-explosive-cart'),
                stockDependent: $('.mobile-explosive-variant-qty .qty-input').add('.mobile-explosive-atc-button'),
                prices: $('.explosive-mobile-variant--price'),
                badge: $('.explosive-mobile-badge--sale'),
                rewards: $('.explosive-mobile-badge--rewards'),
                availability: $('#mobile-explosive-availability')
            };

            var toShopifyAjaxAttr = function (str) {
                return str.trim()
                    .substr(0, str.trim().length - 1)
                    .toLowerCase()
                    .replace(/\s+/, "_");
            };

            this.getCurrentVariantId = function () {
                return _this.$elements.variantId.val();
            };

            this.getCurrentVariant = function () {
                return _this.getVariantFromId(_this.getCurrentVariantId());
            };

            this.getVariantFromId = function (variantId) {
                return _this.variantCache[variantId];
            };

            this.qtyInCart = function (variantId) {
                for (var i = 0, len = _this.cart.items.length; i < len; i++) {
                    if (_this.cart.items[i].id == variantId) return _this.cart.items[i].quantity;
                }
                return 0;
            };
            this.addQtyInCart = function (variantId, qty) {
                var addedQty = false;
                for (var i = 0, len = _this.cart.items.length; i < len; i++) {
                    if (_this.cart.items[i].id == variantId) {
                        _this.cart.items[i].quantity += qty;
                        addedQty = true;
                        break;
                    }
                }
                if (!addedQty) _this.cart.items.push({id: variantId, quantity: qty});
            };

            /**
             * Replaces prices in the mobile form with the prices on the specific variant selected.
             *
             * @param {*} variant
             */
            this.updatePrices = function (variant) {
                var price = variant.price || _this.product.price,
                    comparePrice = variant.compare_at_price || _this.product.compare_at_price,
                    // Boolean for whether or not to make the compare price visible (may be an integer or undefined)
                    compareVisible = comparePrice && comparePrice > price,
                    $compareAt = _this.$elements.prices.find('.price--compare-at .money'),
                    $price = _this.$elements.prices.find('.price--main .money');
                // console.log(comparePrice, 'bbb', $compareAt)
                // price = Shopify.formatMoney(price, 'amount');
                price = Shopify.formatMoney(price);
                comparePrice = Shopify.formatMoney(comparePrice);
                $price.text(price);
                $price.attr('data-currency-usd', price);
                $compareAt.text(comparePrice);
                $compareAt.attr('data-currency-usd', comparePrice);
                if (!compareVisible) _this.$elements.prices.find('.price--compare-at').removeClass('visible');
                else _this.$elements.prices.find('.price--compare-at').addClass('visible');
            };

            /**
             * Change the active form once everything is loaded. Register a list of tasks by tags that report
             * when they are done by calling this.callFinish('tag').
             */
            this._registeredCalls = {};
            this.registerCall = function (tag) {
                _this._registeredCalls[tag] = false;
            };
            this.callFinish = function (tag) {
                _this._registeredCalls[tag] = true;
                for (var key in _this._registeredCalls) {
                    if (!_this._registeredCalls[key]) return;
                }
                // Finished all registered calls
                _this.changeActiveForm(_this.$elements.variantId.val());
            };

            this.changeActiveForm = function (variantId) {
                let variant = _this.getVariantFromId(variantId);
                let MAX_DISPLAY_QTY = 9;
                if (!variant) return;

                let qtyInCart = _this.qtyInCart(variantId);

                // Start Variant Change
                _this.changingVariant = true;
                // Variant Info
                if (variantId != _this.getCurrentVariantId()) _this.$elements.atcSubmitForm.siblings('.explosive-variant-info').remove();
                // Variant ID
                _this.$elements.variantId.val(variantId);
                // Label or Title
                _this.$elements.variantLabel.find('.option-value').text(variant.title.replace(' / ', ' - '));
                // Quantity Input
                _this.$elements.qtyInputs.find('select.qty-input.secondary').change(qtyInputSelected);
                _this.$elements.qtyInputs.find('select.qty-input.secondary').attr('name', 'quantity');
                _this.$elements.qtyInputs.find('select.qty-input.secondary').removeClass('secondary');
                _this.$elements.qtyInputs.find('input.qty-input').addClass('secondary');
                _this.$elements.qtyInputs.find('input.qty-input').removeAttr('name');
             

                // Stock
                var variantQty = _this.variantQuantities[variantId],
                    $select = _this.$elements.qtyInputs.find('select.qty-input')[0];

                if (variantQty <= MAX_DISPLAY_QTY) {
                    _this.$elements.stock.text(variantQty);
                } else {
                    _this.$elements.stock.text(MAX_DISPLAY_QTY + '+');
                }

                // Quantity for purchase vs claimed

                variantQty = variantQty - qtyInCart;
                $select.options.length = 0;
                for (var i = 0; i < variantQty && i < 12; i++) {
                    $select.options[i] = new Option(i + 1, i + 1);
                }
                if (variantQty >= 13) $select.options[12] = new Option("More...", "13");

                if (qtyInCart) {
                    _this.$elements.atcContextMsg.show();
                    _this.$elements.atcContextMsg.text('You have ' + qtyInCart + ' of our stock in cart');
                } else {
                    _this.$elements.atcContextMsg.hide();
                }

                if (variantQty) {
                    _this.$elements.stockDependent.attr('disabled', false);
                } else {
                    _this.$elements.stockDependent.attr('disabled', true);

                }

                if (variant.available) {
                    $('.mobile-explosive-atc-button')
                        .removeClass('button-disabled')
                        .text('Add to Cart')
                } else {
                    // Allow istock click
                    $('.mobile-explosive-atc-button')
                        .attr('disabled', false)
                        .addClass('button-disabled')
                        .text('Sold Out - Notify Me');
                }

                let rewards = false;

                if (_this.$elements.rewards && _this.product.tags.includes('rewards-eligible')) {
                    rewards = true;
                    let rewardQty = 0;
                    for (let k in _this.product.tags) {
                        let tagValues = _this.product.tags[k].split(':');
                        if (tagValues.length == 2 && tagValues[0] == 'reward') {
                            rewardQty = tagValues[1];
                        }
                    }
                    _this.$elements.rewards.show();
                    $('#rewards-amount').text(rewardQty);
                }

                if (!rewards) {
                    if (variant.compare_at_price > variant.price) {
                        let pctoff = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
                        let discountAmount = ((variant.compare_at_price - variant.price) / 100).toFixed(2);
                        _this.$elements.badge.show();
                        // _this.$elements.badge.text('Save ' + pctoff + '%'); // Percentage
                        _this.$elements.badge.text('Save $' + discountAmount); // Dollar amount
                    } else {
                        _this.$elements.badge.hide();
                    }
                }
                if (variant.available) {
                    _this.$elements.availability
                        .text(window.DTAvailability.resolveById(variant.id))
                        .show();
                } else {
                    _this.$elements.availability.hide();
                }


                _this.$elements.qtyInputs.find('.qty-input').val(1);

                // price
                if (_this.product.price_varies) {
                    _this.updatePrices(variant);
                }

                // End Variant Change
                _this.changingVariant = false;
            };

            var pathArray = window.location.pathname.split(/\//), productHandle = pathArray[pathArray.length - 1];
            _this.registerCall('product');
            _this.registerCall('cart');
            $.getJSON("/products/" + productHandle + ".js", function (response) {
                _this.product = response;

                if (_this.product.variants && _this.product.variants.length) {
                    for (var i = 0, len = _this.product.variants.length; i < len; i++) {
                        var variant = _this.product.variants[i];
                        _this.variantCache[variant.id] = variant;
                    }
                    _this.currentVariant = _this.getVariantFromId(_this.$elements.variantId.val());
                    if (window.variantQuantitiesJSON) {
                        _this.variantQuantities = JSON.parse(window.variantQuantitiesJSON);
                    }
                }
                _this.callFinish('product');
            });
            $.getJSON("/cart.js", function (response) {
                _this.cart = response;
                _this.callFinish('cart');
            });
            this.$elements.qtyInputs.find('select.qty-input').change(qtyInputSelected);
            this.$elements.atcForm.submit(function (event) {
                event.preventDefault();

                // Updating only one value
                var variantId = _this.$elements.variantId.val(),
                    addedQty = parseInt(_this.$elements.qtyInputs.find('.qty-input:not(.secondary)').val(), 10),
                    postData = {
                        quantity: addedQty,
                        id: variantId
                    };

                if (!addedQty) {
                    oosClick(variantId);
                    return;
                }

                // Update all variant values
                // $.post('/cart/update.js', {updates: _this.getUpdateCart()})
                $.post('/cart/add.js', postData, null, 'json')
                    .done(function () {

                        // Report results
                        _this.$elements.qtyInputs.find('.qty-input:not(.secondary)').val(0);
                        variantInform({
                            text: "Added " + addedQty + " to your <a href='/cart' title='View shopping cart'>shopping cart.</a>",
                            classes: 'success text-center',
                            dismissable: false
                        }, _this.$elements.atcSubmitForm);
                        _this.addQtyInCart(variantId, addedQty);
                        _this.changeActiveForm(variantId);

                        // Update cart in header
                        var headerCartQty = parseInt($('.site-header-cart--count').data('header-cart-count')) || 0;
                        updateHeaderCartWidget(addedQty + headerCartQty);
                    })
                    .fail(function (e) {
                        if (!e || !e.responseText) return;
                        var available = _this.variantQuantities[variantId] - _this.qtyInCart(variantId);
                        // TODO: Add internationalization support
                        if (available < 1) variantInform({
                            text: "None Available to Add&mdash;Click Here to Continue",
                            classes: 'fail'
                        }, _this.$elements.atcSubmitForm);
                        else variantInform({
                            text: "Only " + available + " Available to Add&mdash;Click Here to Continue",
                            classes: 'fail'
                        }, _this.$elements.atcSubmitForm);
                    });
            });
            return this;
        };

        window.MobileExplosivePDP = new MobileExplosiveHandler();
        (new window.ExplosivePDP()).init();


       jQuery('.gallery-thumbs .swiper-slide').click(function () {
         var data_varId = jQuery(this).attr('data-variantId');
          if (data_varId) {
              // console.log(data_varId);
              window.MobileExplosivePDP.changeActiveForm(data_varId);
             jQuery('.selected-variant-id').val(data_varId);
          }
         
       }) 
  

        // $('.explosive-variant-image-button').on('click', function () {
        //     let targetModal = $('#explosive-target-content');
        //     let targetModalImg = targetModal.find('img');

        //     targetModal.find('label').html($(this).data('color'));
        //     //targetModal.find('img').attr('src', $(this).data('img'));
        //     $(targetModalImg).attr('src', $(this).data('img'));

        //     if ($(this).data('img-zoom')) {
        //         $(targetModalImg).attr('data-zoom', $(this).data('img-zoom'));
        //     } else {
        //         $(targetModalImg).removeClass('image-zoom');
        //     }

        //     refreshZoom();
        //     alertModal.render('explosive-target');
        // });
    // }





class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);




  

//   class LocalizationForm extends HTMLElement {
//   constructor() {
//     super();
//     this.elements = {
//       input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
//       button: this.querySelector('button'),
//       panel: this.querySelector('ul'),
//     };
//     this.elements.button.addEventListener('click', this.openSelector.bind(this));
//     this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
//     this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

//     this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
//   }

//   hidePanel() {
//     this.elements.button.setAttribute('aria-expanded', 'false');
//     this.elements.panel.setAttribute('hidden', true);
//   }

//   onContainerKeyUp(event) {
//     if (event.code.toUpperCase() !== 'ESCAPE') return;

//     this.hidePanel();
//     this.elements.button.focus();
//   }

//   onItemClick(event) {
//     const form = this.querySelector('form');
//     this.elements.input.value = event.currentTarget.dataset.value;
//     if (form) form.submit(function () {
//       return false;
//     });
//     // event.preventDefault();
//   }

//   openSelector() {
//     this.elements.button.focus();
//     this.elements.panel.toggleAttribute('hidden');
//     this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
//   }

//   closeSelector(event) {
//     const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
//     if (event.relatedTarget === null || shouldClose) {
//       this.hidePanel();
//     }
//   }
// }

// customElements.define('localization-form', LocalizationForm);


  

  
});